// extracted by mini-css-extract-plugin
module.exports = {"Btn":"TrainingsPage_Btn__3q214","TrainingsPage":"TrainingsPage_TrainingsPage__ZRhxR"};